import { useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';

export default function ScrollTop() {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return <React.Fragment />;
}
